import { useState } from 'react'
import Text from 'components/shared/Text'

import Box from 'components/shared/Box'
import { BenefitsInfoBox } from 'components/global/BenefitsInfo/styles'

import { useResolutions } from 'store/resolutions'
import Icon from 'components/shared/Icon'
import { FormattedMessage } from 'react-intl'

const UnlimitedBenefitsInfo = () => {
    const { isTablet } = useResolutions()
    const [isBenefitInfoVisible, setIsBenefitInfoVisible] = useState(false)

    const BenefitsBoxTitle = () => (
        <Box>
            <Text variant="heading4" color="primary_500">
                <FormattedMessage
                    id="global.benefits.section_caption_unlimited"
                    defaultMessage="<span>Zapłać raz,</span> korzystaj ile chcesz"
                    description="Keep the html tags in the translation"
                    values={{
                        span: (chunks: string[]) => (
                            <>
                                <Text
                                    as="span"
                                    variant="heading4"
                                    color="grayscale_900"
                                >
                                    {chunks}
                                </Text>
                                <br />
                            </>
                        ),
                    }}
                />
            </Text>
        </Box>
    )

    return (
        <BenefitsInfoBox gap={32} padding={[32, 38]} mt={[16, 138]}>
            {!isTablet ? (
                <BenefitsBoxTitle />
            ) : (
                <Box
                    direction="row"
                    justify="space-between"
                    align="center"
                    onClick={() =>
                        setIsBenefitInfoVisible(!isBenefitInfoVisible)
                    }
                >
                    <BenefitsBoxTitle />
                    <Icon
                        variant="chevron"
                        color="primary_500"
                        rotation={isBenefitInfoVisible ? 180 : 0}
                    />
                </Box>
            )}
            {(!isTablet || (isBenefitInfoVisible && isTablet)) && (
                <>
                    <Box gap={8}>
                        <Box direction="row">
                            <Text variant="bodySmallStrong" color="primary_500">
                                <FormattedMessage
                                    id="global.benefits.unlimited_visits"
                                    defaultMessage="Nielimitowane <span>wejścia</span>"
                                    description="Keep the html tags in the translation"
                                    values={{
                                        span: (chunks: string[]) => (
                                            <>
                                                <Text
                                                    as="span"
                                                    variant="bodySmallStrong"
                                                    color="grayscale_900"
                                                >
                                                    {chunks}
                                                </Text>
                                            </>
                                        ),
                                    }}
                                />
                                &nbsp;
                            </Text>
                        </Box>
                        <Text variant="bodyExtraSmall" color="grayscale_900">
                            <FormattedMessage
                                id="global.benefits.unlimited_visits_body"
                                defaultMessage="Korzystaj z parku ile chcesz i kiedy chcesz, przez cały rok"
                            />
                        </Text>
                    </Box>
                    <Box gap={8}>
                        <Box direction="row">
                            <Text variant="bodySmallStrong" color="primary_500">
                                <FormattedMessage
                                    id="global.benefits.all_zones_access"
                                    defaultMessage="<span>Pełen dostęp do stref</span> Jamango i Relax"
                                    description="Keep the html tags in the translation"
                                    values={{
                                        span: (chunks: string[]) => (
                                            <>
                                                <Text
                                                    as="span"
                                                    variant="bodySmallStrong"
                                                    color="grayscale_900"
                                                >
                                                    {chunks}
                                                </Text>
                                            </>
                                        ),
                                    }}
                                />
                                &nbsp;
                            </Text>
                        </Box>
                        <Text variant="bodyExtraSmall" color="grayscale_900">
                            <FormattedMessage
                                id="global.benefits.all_zones_access_body"
                                defaultMessage="Ciesz się nieograniczonym dostępem do głównych atrakcji!"
                            />
                        </Text>
                    </Box>
                </>
            )}
        </BenefitsInfoBox>
    )
}

export default UnlimitedBenefitsInfo
